import { Link } from 'react-router-dom';

export default function Landing() {
  return (
    <div>
      <section className="hero">
        <span className="eyebrow bordered rise rise-1">A registry for what matters</span>
        <h1 className="rise rise-2 mt-24">
          Recover what is <em>yours</em>,<br/>
          one bounty at a time.
        </h1>
        <p className="lede rise rise-3">
          Catalogue your belongings. Set a reward. If a stranger finds it,
          they upload a photo and the moment they mark it found, you'll know —
          by email or text, whichever you prefer.
        </p>
        <div className="actions rise rise-4">
          <Link to="/signup" className="btn btn-primary">Open an inventory</Link>
          <Link to="/signin" className="btn btn-ghost">I already have one</Link>
        </div>
        {/* Decorative luggage tag — shown by the office theme only. */}
        <div className="hero-tag" aria-hidden="true">
          <div className="ht-no">No. 7KQ4M2XA</div>
          <div className="ht-name">Brown leather wallet</div>
          <div className="ht-lines">
            <div><span>Owner</span> notified by text</div>
            <div><span>Finder</span> no account needed</div>
          </div>
          <div className="ht-stamp">Reward $50</div>
        </div>
      </section>

      <section className="landing-section">
        <div className="steps">
          <Step n="I" title="Inventory">
            Add each item that matters — a passport, a bicycle, a wedding ring.
            Attach a photo, identifying marks, and a bounty in any amount.
          </Step>
          <Step n="II" title="Share a tag">
            Print a small QR sticker linked to the item's claim page, or simply
            note the item ID inside the object. No one but the finder needs to know.
          </Step>
          <Step n="III" title="Be notified">
            When a finder reports it, an alert hits your inbox or phone instantly.
            Approve, arrange handoff, pay the bounty. Item recovered.
          </Step>
        </div>
      </section>

      <section className="landing-section">
        <h2 className="mb-24">Why a bounty?</h2>
        <p className="landing-copy">
          A small reward tilts the math. A finder who would have shrugged and
          walked on is suddenly motivated to look up the tag, take a photo, and reach out.
          Bounties also make recovery feel fair — both parties leave with something.
        </p>
      </section>
    </div>
  );
}

function Step({ n, title, children }) {
  return (
    <div>
      <div className="step-num">{n}</div>
      <h3 className="mb-8">{title}</h3>
      <p className="step-copy">{children}</p>
    </div>
  );
}
